import { Spin } from "antd";

export const Loader = () => (
  <div style={{ height: 300, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <Spin size="large" />
  </div>
);
